import client from '../client';

export interface Sewer {
  Id: number;
  FirstName: string;
  LastName: string;
  Tag: string;
}

export interface SewerAssignmentRequest {
  sewerId: number;
  orderItemNumber: string;
}

export interface SewerAssignmentHistory {
  PartNumber: string;
  CreateDate: string;
  FirstName: string;
  LastName: string;
}

export interface SewerAssignmentResponse {
  success: boolean;
  data?: SewerAssignmentHistory[] | { actionId: number; sewer?: string };
  message?: string;
}

export const sewerPickupService = {
  /**
   * Get all sewers
   */
  getSewers: async (): Promise<Sewer[]> => {
    const response: any = await client.get('/sewer-pickup/sewers');
    return response.data;
  },

  /**
   * Assign sewer to order item
   */
  assignSewer: async (data: SewerAssignmentRequest): Promise<SewerAssignmentResponse> => {
    const response: any = await client.post('/sewer-pickup/assign', data);
    const body = response.data;
    // The interceptor unwraps { success: true, data: X } → X (the history array).
    // Failure responses { success: false, ... } are not unwrapped and pass through as-is.
    if (Array.isArray(body)) {
      return { success: true, data: body };
    }
    return body;
  },

  /**
   * Re-assign a sewer for an item already In Sewing
   */
  reassignSewer: async (itemId: number, sewerId: number): Promise<void> => {
    await client.post('/sewer-pickup/reassign', { itemId, sewerId });
  }
};
